import { getCurrentPosition } from './GPS';
import { checkLocationIsOkinawa } from './Utils';

export const checkCurrentLocationIsOkinawa = async () => {
  let isInOkinawa = false;
  try {
    const {
      coords: { latitude, longitude }
    } = await getCurrentPosition();
    isInOkinawa = checkLocationIsOkinawa(latitude, longitude);
  } catch (e) {
    console.log(e);
  }
  return isInOkinawa;
};
